<div class="wishes-shell">
  <div class="subtab-bar">
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'create'"
      (click)="setSubTab('create')">
      Create wishes
    </button>
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'view'"
      (click)="setSubTab('view')">
      View wishes
    </button>
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'templates'"
      (click)="setSubTab('templates')">
      Wishes Template
    </button>
    <!--
    <button
      type="button"
      class="subtab"
      [class.active]="activeSubTab === 'track'"
      (click)="setSubTab('track')">
      Track wishes
    </button>
    -->
  </div>

  <ng-template #wishFormFields let-form="form" let-lockActionIdentity="lockActionIdentity">
    <div class="form-row wish-top-row">
      <div class="field">
        <label>Wishes Name</label>
        <input class="control" type="text" [(ngModel)]="form.wishName" placeholder="Enter wish name" />
      </div>
      <div class="field field-grow">
        <label>Wishes Description</label>
        <input class="control" type="text" [(ngModel)]="form.wishDescription" placeholder="Enter wish description" />
      </div>
      <div class="field field-weeks">
        <label>Number of weeks</label>
        <select
          class="control"
          [(ngModel)]="form.wishNumberOfWeeks"
          [disabled]="form.isEnrolled"
          (ngModelChange)="onWishNumberOfWeeksChange(form)">
          <option [ngValue]="null">Select number of weeks</option>
          <option [ngValue]="1">1 week</option>
          <option [ngValue]="2">2 weeks</option>
          <option [ngValue]="3">3 weeks</option>
          <option [ngValue]="4">4 weeks</option>
          <option [ngValue]="5">5 weeks</option>
          <option [ngValue]="6">6 weeks</option>
        </select>
      </div>
      <div class="field field-card-for-app">
        <label>Card for App</label>
        <select class="control" [(ngModel)]="form.cardForApp">
          <option [ngValue]="null">Select card for app</option>
          <option *ngFor="let card of cardForAppOptions" [ngValue]="card">{{ card }}</option>
        </select>
      </div>
    </div>

    <ng-container *ngFor="let slot of form.actionSlots; let i = index">
      <div *ngIf="slot.type === 'select'" class="form-row form-row-actions">
        <div class="field field-actions">
          <label>Actions</label>
          <select
            class="control"
            #actionSelect
            (change)="onActionSelect(form, i, actionSelect.value); actionSelect.value = ''">
            <option value="">Choose action</option>
            <option value="goal" [disabled]="form.isEnrolled">Goal</option>
            <option value="habit">Habit</option>
          </select>
        </div>
      </div>

      <div *ngIf="slot.type === 'goal'" class="action-card action-card--goal">
        <div class="section-heading action-card__heading">Goal</div>
        <div class="form-row">
          <div class="field">
            <label>Goal Pillar</label>
            <select
              class="control"
              [(ngModel)]="slot.goalPillar"
              [disabled]="isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled"
              (ngModelChange)="onGoalSlotPillarChange(form, i)">
              <option [ngValue]="null">Choose pillar</option>
              <option *ngFor="let p of goalPillarOptions" [ngValue]="p.value">{{ p.label }}</option>
            </select>
          </div>
          <div class="field field-grow">
            <label>Goal</label>
            <select
              class="control"
              [(ngModel)]="slot.goalFieldKey"
              [disabled]="!slot.goalPillar || isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled"
              (ngModelChange)="onGoalSlotFieldKeyChange(form, i)">
              <option [ngValue]="null">Choose goal</option>
              <option
                *ngFor="let g of goalsForWishPillar(slot.goalPillar)"
                [ngValue]="g.key"
                [disabled]="isWishGoalTaken(form, i, slot.goalPillar, g.key)">
                {{ g.label }}
              </option>
            </select>
          </div>
          <div class="field field-goal-value">
            <label>Goal value</label>
            <select
              *ngIf="isWishBedTimeGoal(slot.goalPillar, slot.goalFieldKey)"
              class="control"
              [(ngModel)]="slot.goalValue"
              [disabled]="!slot.goalFieldKey || isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled">
              <option value="" disabled>Select bed time</option>
              <option *ngFor="let option of bedTimeOptions" [ngValue]="option">{{ option }}</option>
            </select>
            <input
              *ngIf="!isWishBedTimeGoal(slot.goalPillar, slot.goalFieldKey) && isWishFastingGlucoseGoal(slot.goalFieldKey)"
              class="control"
              type="text"
              [(ngModel)]="slot.goalValue"
              [disabled]="!slot.goalFieldKey || isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled"
              placeholder="e.g. 80-120" />
            <input
              *ngIf="!isWishBedTimeGoal(slot.goalPillar, slot.goalFieldKey) && !isWishFastingGlucoseGoal(slot.goalFieldKey)"
              class="control"
              type="number"
              step="any"
              [(ngModel)]="slot.goalValue"
              [disabled]="!slot.goalFieldKey || isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled"
              placeholder="Enter value" />
          </div>
          <div class="field field-grow">
            <label>Goal description</label>
            <input
              class="control"
              type="text"
              [(ngModel)]="slot.goalDescription"
              [disabled]="isEditActionIdentityLocked(lockActionIdentity, slot) || form.isEnrolled"
              placeholder="Goal description" />
          </div>
          <div class="field">
            <label>Frequency</label>
            <select
              class="control"
              [(ngModel)]="slot.frequency"
              [disabled]="form.isEnrolled"
              (ngModelChange)="onActionFrequencyChange(form, i, $event)">
              <option [ngValue]="''">Choose frequency</option>
              <option [ngValue]="'daily'">Daily</option>
            </select>
          </div>
          <div class="actions" *ngIf="!form.isEnrolled">
            <button type="button" class="btn-delete" (click)="onDeleteActionSlot(form, i)">Delete</button>
          </div>
        </div>
        <div *ngIf="slot.frequency === 'weekly'" class="form-row form-row-weekdays">
          <div class="field field-weekdays-full">
            <label>Weekdays</label>
            <p class="weekday-hint">
              Select days for this week. Click a highlighted day again to remove it.
            </p>
            <div class="weekday-toggles" role="group" aria-label="Weekdays">
              <button
                type="button"
                *ngFor="let d of weekdayOptions"
                class="weekday-chip"
                [class.weekday-chip--selected]="isWeekdaySelected(form, i, d.key)"
                [disabled]="form.isEnrolled"
                [attr.aria-pressed]="isWeekdaySelected(form, i, d.key)"
                [title]="d.label"
                (click)="toggleWeekdaySlot(form, i, d.key)">
                {{ d.shortLabel }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="slot.type === 'habit'" class="action-card action-card--habit">
        <div class="section-heading action-card__heading">Habit</div>
        <div class="form-row form-row--habit-fields">
          <div class="field">
            <label>Habit Name</label>
            <select
              class="control"
              [(ngModel)]="slot.habitNameId"
              (ngModelChange)="onHabitSlotHabitChange(form, i)"
              [disabled]="isLoadingReminderCategories || isEditActionIdentityLocked(lockActionIdentity, slot) || isHabitActionFrozen(form, slot)">
              <option [ngValue]="null">Choose Habit</option>
              <option *ngFor="let h of habitItems" [ngValue]="h.id">{{ h.name }}</option>
            </select>
          </div>
          <div class="field">
            <label>Category</label>
            <select
              class="control"
              [(ngModel)]="slot.nameId"
              (ngModelChange)="onHabitSlotCategoryChange(form, i)"
              [disabled]="isLoadingReminderCategories || !slot.habitNameId || isEditActionIdentityLocked(lockActionIdentity, slot) || isHabitActionFrozen(form, slot)">
              <option [ngValue]="null">Choose Category</option>
              <option *ngFor="let c of categoryOptionsForHabit(slot.habitNameId)" [ngValue]="c.nameId">
                {{ c.label }}
              </option>
            </select>
          </div>
          <div class="field">
            <label>Frequency</label>
            <select
              class="control"
              [(ngModel)]="slot.frequency"
              [disabled]="isHabitActionFrozen(form, slot)"
              (ngModelChange)="onActionFrequencyChange(form, i, $event)">
              <option [ngValue]="''">Choose frequency</option>
              <option *ngFor="let opt of habitFrequencyOptions" [ngValue]="opt.value">
                {{ opt.label }}
              </option>
            </select>
          </div>
          <div class="field field-grow">
            <label>Habit journey description</label>
            <input
              class="control"
              type="text"
              [(ngModel)]="slot.habitJourneyDescription"
              (ngModelChange)="onHabitJourneyDescriptionChange(slot)"
              [disabled]="isHabitActionFrozen(form, slot)"
              placeholder="Enter habit journey description (optional)" />
            <p *ngIf="slot.habitDescriptionMismatchWarning" class="habit-description-warning">
              ⚠️ Description may no longer match the selected habit. Please review/update.
            </p>
          </div>
          <div class="field field-habit-time">
            <label>Time</label>
            <div class="habit-time-row">
              <input
                class="control control-habit-time"
                type="time-24"
                [ngModel]="slot.habitTime[0]"
                (ngModelChange)="onHabitTimeChange(form, i, 0, $event)"
                [ngModelOptions]="{ standalone: true }"
                [ngxTimepicker]="habitTimePicker0"
                [format]="24"
                [disabled]="isHabitActionFrozen(form, slot)"
                placeholder="Pick time" />
              <ngx-material-timepicker #habitTimePicker0 [format]="24"></ngx-material-timepicker>
              <button
                type="button"
                class="btn-time-remove"
                *ngIf="slot.habitTime.length > 1 && !isHabitActionFrozen(form, slot)"
                (click)="removeHabitTimeField(form, i, 0)"
                aria-label="Remove time">
                &times;
              </button>
            </div>
            <div class="habit-extra-times">
              <ng-container *ngFor="let t of slot.habitTime; let ti = index">
                <div *ngIf="ti > 0" class="habit-time-row">
                  <input
                    class="control control-habit-time"
                    type="time-24"
                    [ngModel]="t"
                    (ngModelChange)="onHabitTimeChange(form, i, ti, $event)"
                    [ngModelOptions]="{ standalone: true }"
                    [ngxTimepicker]="extraTimePicker"
                    [format]="24"
                    [disabled]="isHabitActionFrozen(form, slot)"
                    placeholder="Pick time" />
                  <ngx-material-timepicker #extraTimePicker [format]="24"></ngx-material-timepicker>
                  <button
                    type="button"
                    class="btn-time-remove"
                    *ngIf="!isHabitActionFrozen(form, slot)"
                    (click)="removeHabitTimeField(form, i, ti)"
                    aria-label="Remove time">
                    &times;
                  </button>
                </div>
              </ng-container>
              <button
                type="button"
                class="btn-time-add"
                *ngIf="!isHabitActionFrozen(form, slot)"
                (click)="addHabitTimeField(form, i)">
                + Add time
              </button>
            </div>
          </div>
          <div class="actions" *ngIf="!isHabitActionFrozen(form, slot)">
            <button type="button" class="btn-delete" (click)="onDeleteActionSlot(form, i)">Delete</button>
          </div>
        </div>
        <div *ngIf="slot.type === 'habit' && slot.frequency === 'weekly'" class="form-row form-row-weekdays">
          <div class="field field-weekdays-full">
            <label>Weekdays</label>
            <p class="weekday-hint">
              Select days for this week. Click a highlighted day again to remove it.
            </p>
            <div class="weekday-toggles" role="group" aria-label="Weekdays">
              <button
                type="button"
                *ngFor="let d of weekdayOptions"
                class="weekday-chip"
                [class.weekday-chip--selected]="isWeekdaySelected(form, i, d.key)"
                [disabled]="isHabitActionFrozen(form, slot)"
                [attr.aria-pressed]="isWeekdaySelected(form, i, d.key)"
                [title]="d.label"
                (click)="toggleWeekdaySlot(form, i, d.key)">
                {{ d.shortLabel }}
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="slot.type === 'habit'" class="form-row form-row-weekdays">
          <div class="field field-weekdays-full">
            <label>Weekly Applied <span style="color:#b00020">*</span></label>
            <p class="weekday-hint" *ngIf="!form.wishNumberOfWeeks">
              Select number of weeks above to configure weekly applied.
            </p>
            <div *ngIf="form.wishNumberOfWeeks" class="weekday-toggles" role="group" aria-label="Weekly Applied">
              <button
                type="button"
                class="weekday-chip"
                [class.weekday-chip--selected]="isAllWeeksApplied(form, i)"
                [disabled]="form.isEnrolled && !isHabitActionAllWeeksFromApi(form, slot)"
                [attr.aria-pressed]="isAllWeeksApplied(form, i)"
                (click)="toggleAllWeeksApplied(form, i)">
                All weeks
              </button>
              <button
                type="button"
                *ngFor="let w of getWeekRange(form)"
                class="weekday-chip"
                [class.weekday-chip--selected]="!isAllWeeksApplied(form, i) && isWeekApplied(form, i, w)"
                [disabled]="isAllWeeksApplied(form, i) || isWeekFrozenByEnrollment(form, w)"
                [attr.aria-pressed]="!isAllWeeksApplied(form, i) && isWeekApplied(form, i, w)"
                (click)="toggleWeekApplied(form, i, w)">
                {{ weekOrdinalLabel(w) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="form.weeklyNotes.length > 0" class="weekly-notes-section">
      <div
        *ngFor="let entry of form.weeklyNotes"
        class="form-row form-row-weekly-note">
        <div class="field field-care-team-notes">
          <label>Week: {{ entry.week }}</label>
          <textarea
            class="control control-textarea"
            rows="3"
            [(ngModel)]="entry.notes"
            [attr.placeholder]="'Enter notes for week ' + entry.week"></textarea>
        </div>
      </div>
    </div>

    <div class="form-row form-row-care-team-notes">
      <div class="field field-care-team-notes">
        <label>Care team notes</label>
        <textarea
          class="control control-textarea"
          rows="4"
          [(ngModel)]="form.careTeamNotes"
          placeholder="Enter care team notes"></textarea>
      </div>
    </div>
  </ng-template>

  <div *ngIf="activeSubTab === 'create'" class="subtab-panel create-wishes-panel wish-form-panel">
    <ng-container *ngTemplateOutlet="wishFormFields; context: { form: createForm, lockActionIdentity: false }"></ng-container>
    <div class="create-wishes-footer">
      <button
        type="button"
        class="primary"
        (click)="createWish()"
        [disabled]="wishSubmitting || !isWishFormComplete(createForm, { requireCardForApp: true })">
        {{ wishSubmitting ? 'Creating…' : 'Create wish' }}
      </button>
    </div>
  </div>

  <div *ngIf="activeSubTab === 'view'" class="subtab-panel view-wishes-panel">
    <div *ngIf="!(memberId ?? '').toString().trim()" class="cards-muted">
      Member is required to load wishes.
    </div>
    <ng-container *ngIf="(memberId ?? '').toString().trim()">
      <div *ngIf="isLoadingMemberWishes" class="cards-muted">Loading wishes…</div>
      <div *ngIf="!isLoadingMemberWishes && memberWishes.length === 0" class="cards-muted">
        No wishes found.
      </div>
      <ul *ngIf="!isLoadingMemberWishes && memberWishes.length > 0" class="wish-view-list">
        <li *ngFor="let w of memberWishes; let wi = index" class="wish-view-card">
          <div class="wish-card-top">
            <div class="wish-card-title">
              {{ w.wishName || 'Wish' }}<ng-container *ngIf="viewOngoingWeekLabel(w) as ongoingLabel"> <span class="wish-card-ongoing-week">({{ ongoingLabel }})</span></ng-container>
            </div>
            <div class="wish-card-top-right">
              <span *ngIf="w.isEnrolled" class="wish-logged-at">
                Enrolled at: {{ formatWishLoggedAt(w.enrolledDateTime) }}
              </span>
              <span class="wish-logged-at">
                Logged at: {{ formatWishLoggedAt(w.createdDateTime) }}
              </span>
              <span *ngIf="isWishInProgressForView(w)" class="wish-status wish-status--in-progress">In progress</span>
              <span *ngIf="isWishCompletedByEndDate(w)" class="wish-status wish-status--completed">Completed</span>
              <span *ngIf="w.isArchived" class="wish-status wish-status--archived">Archived</span>
            </div>
          </div>
          <div *ngIf="w.wishDescription" class="wish-card-desc">{{ w.wishDescription }}</div>
          <div class="wish-card-duration">
            <span>Duration - {{ wishDurationWeeksLabel(w) }}</span>
            <button
              type="button"
              class="wish-card-expand-btn"
              (click)="toggleViewWishCardExpanded(w, wi)"
              [attr.aria-expanded]="isViewWishCardExpanded(w, wi)"
              [attr.aria-label]="isViewWishCardExpanded(w, wi) ? 'Collapse wish details' : 'Expand wish details'">
              <span
                class="wish-card-expand-arrow"
                [class.wish-card-expand-arrow--open]="isViewWishCardExpanded(w, wi)">▼</span>
            </button>
          </div>
          <div *ngIf="isViewWishCardExpanded(w, wi)" class="wish-card-details">
            <div *ngIf="(w.actions?.length ?? 0) > 0" class="wish-actions">
              <ng-container *ngFor="let a of w.actions ?? []">
                <div *ngIf="isViewGoalAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">{{ a.goalPillar }} - {{ a.goal }}</span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="viewGoalValueLine(a)" class="wish-action-sub">{{ viewGoalValueLine(a) }}</div>
                  <div *ngIf="a.goalDescription" class="wish-action-sub">{{ a.goalDescription }}</div>
                </div>

                <div *ngIf="isViewHabitAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">
                      <span *ngIf="habitWeeksAppliedLabel(w, a) as wl" class="habit-weeks-tag">{{ wl }}</span>{{ a.title }}<ng-container *ngIf="formatViewHabitTime(a) as ht"> ({{ ht }})</ng-container>
                    </span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="habitViewDescription(a)" class="wish-action-sub">{{ habitViewDescription(a) }}</div>
                </div>

                <div *ngIf="isViewMoodAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">{{ a.moodCheckInName }}</span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="a.moodCheckInDescription" class="wish-action-sub">{{ a.moodCheckInDescription }}</div>
                </div>
              </ng-container>
            </div>

            <div *ngIf="w.careTeamNotes" class="wish-card-care-notes">
              <span class="wish-card-care-notes-label">Care Team Notes:</span>
              {{ w.careTeamNotes }}
            </div>

            <div class="wish-card-footer wish-card-footer--actions">
              <button
                *ngIf="!isWishCompletedByEndDate(w)"
                type="button"
                class="btn-edit-wish"
                (click)="openEditWishModal(w)">
                Edit Wish
              </button>
              <button
                *ngIf="showSaveAsArchivedButton(w)"
                type="button"
                class="btn-save-archived"
                (click)="saveWishAsArchived(w)"
                [disabled]="isArchivingWish(w)">
                {{ isArchivingWish(w) ? 'Saving…' : 'Save as Archive' }}
              </button>
              <button
                *ngIf="showRemoveFromArchiveButton(w)"
                type="button"
                class="btn-remove-archived"
                (click)="removeWishFromArchive(w)"
                [disabled]="isArchivingWish(w)">
                {{ isArchivingWish(w) ? 'Saving…' : 'Remove from Archive' }}
              </button>
              <button
                *ngIf="showSaveAsTemplateButton(w)"
                type="button"
                class="btn-save-template"
                (click)="saveWishAsTemplate(w)"
                [disabled]="isSavingWishTemplate(w)">
                {{ isSavingWishTemplate(w) ? 'Saving…' : 'Save as template' }}
              </button>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>

  <div *ngIf="activeSubTab === 'track'" class="subtab-panel track-wishes-panel">
    <app-wishes-track [memberId]="memberId"></app-wishes-track>
  </div>

  <div *ngIf="activeSubTab === 'templates'" class="subtab-panel view-wishes-panel">
    <div *ngIf="!(memberId ?? '').toString().trim()" class="cards-muted">
      Member is required to load wish templates.
    </div>
    <ng-container *ngIf="(memberId ?? '').toString().trim()">
      <div *ngIf="isLoadingMemberWishTemplates" class="cards-muted">Loading wish templates…</div>
      <div *ngIf="!isLoadingMemberWishTemplates && memberWishTemplates.length === 0" class="cards-muted">
        No wish templates found.
      </div>
      <ul *ngIf="!isLoadingMemberWishTemplates && memberWishTemplates.length > 0" class="wish-view-list">
        <li *ngFor="let w of memberWishTemplates; let wi = index" class="wish-view-card">
          <div class="wish-card-top">
            <div class="wish-card-title">{{ w.wishName || 'Wish template' }}</div>
            <div class="wish-card-top-right">
              <span class="wish-logged-at">
                Logged at: {{ formatWishLoggedAt(w.createdDateTime) }}
              </span>
            </div>
          </div>
          <div *ngIf="w.wishDescription" class="wish-card-desc">{{ w.wishDescription }}</div>
          <div class="wish-card-duration">
            <span>Duration - {{ wishDurationWeeksLabel(w) }}</span>
            <button
              type="button"
              class="wish-card-expand-btn"
              (click)="toggleTemplateWishCardExpanded(w, wi)"
              [attr.aria-expanded]="isTemplateWishCardExpanded(w, wi)"
              [attr.aria-label]="isTemplateWishCardExpanded(w, wi) ? 'Collapse wish template details' : 'Expand wish template details'">
              <span
                class="wish-card-expand-arrow"
                [class.wish-card-expand-arrow--open]="isTemplateWishCardExpanded(w, wi)">▼</span>
            </button>
          </div>
          <div *ngIf="isTemplateWishCardExpanded(w, wi)" class="wish-card-details">
            <div *ngIf="(w.actions?.length ?? 0) > 0" class="wish-actions">
              <ng-container *ngFor="let a of w.actions ?? []">
                <div *ngIf="isViewGoalAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">{{ a.goalPillar }} - {{ a.goal }}</span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="viewGoalValueLine(a)" class="wish-action-sub">{{ viewGoalValueLine(a) }}</div>
                  <div *ngIf="a.goalDescription" class="wish-action-sub">{{ a.goalDescription }}</div>
                </div>

                <div *ngIf="isViewHabitAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">
                      <span *ngIf="habitWeeksAppliedLabel(w, a) as wl" class="habit-weeks-tag">{{ wl }}</span>{{ a.title }}<ng-container *ngIf="formatViewHabitTime(a) as ht"> ({{ ht }})</ng-container>
                    </span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="habitViewDescription(a)" class="wish-action-sub">{{ habitViewDescription(a) }}</div>
                </div>

                <div *ngIf="isViewMoodAction(a)" class="wish-view-action">
                  <div class="wish-action-row">
                    <span class="wish-action-main">{{ a.moodCheckInName }}</span>
                    <span class="wish-action-freq">{{ formatViewActionFrequency(a) }}</span>
                  </div>
                  <div *ngIf="a.moodCheckInDescription" class="wish-action-sub">{{ a.moodCheckInDescription }}</div>
                </div>
              </ng-container>
            </div>

            <div *ngIf="w.careTeamNotes" class="wish-card-care-notes">
              <span class="wish-card-care-notes-label">Care Team Notes:</span>
              {{ w.careTeamNotes }}
            </div>
          </div>

          <div class="wish-card-footer">
            <button
              type="button"
              class="btn-save-template"
              (click)="useWishTemplate(w)">
              Use this Template
            </button>
          </div>
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="wish-edit-modal-backdrop" *ngIf="editWishModalVisible" (click)="closeEditWishModal()">
    <div class="wish-edit-modal" (click)="$event.stopPropagation()">
      <div class="wish-edit-modal-header">
        <h2 class="wish-edit-modal-title">
          Edit Wish<ng-container *ngIf="ongoingWeekLabel(editForm) as ongoingLabel"> ({{ ongoingLabel }})</ng-container>
        </h2>
        <button type="button" class="wish-edit-modal-close" (click)="closeEditWishModal()" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>
      <div class="wish-edit-modal-body wish-form-panel">
        <ng-container *ngTemplateOutlet="wishFormFields; context: { form: editForm, lockActionIdentity: false }"></ng-container>
      </div>
      <div class="wish-edit-modal-footer">
        <button type="button" class="btn-modal-cancel" (click)="closeEditWishModal()">Cancel</button>
        <button
          type="button"
          class="primary"
          (click)="updateWish()"
          [disabled]="editWishSubmitting || !isWishFormComplete(editForm, { requireCardForApp: true }) || !isEditWishFormDirty()">
          {{ editWishSubmitting ? 'Updating…' : 'Update wish' }}
        </button>
      </div>
    </div>
  </div>

</div>
